import { render, staticRenderFns } from "./SignupDashboard.vue?vue&type=template&id=4188b01f"
import script from "./SignupDashboard.vue?vue&type=script&lang=js"
export * from "./SignupDashboard.vue?vue&type=script&lang=js"
import style0 from "./SignupDashboard.vue?vue&type=style&index=0&id=4188b01f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports